import * as Yup from 'yup';

export const updateLopFormSchema = Yup.object({
  correctionLop: Yup.number().typeError('Value must be a number').nullable()
});

export const updateOvertimeFormSchema = Yup.object({
  correctionOvertime: Yup.number().typeError('Value must be a number').nullable()
});

export const lOPOvertimeRequestFormSchema = Yup.object({
  days: Yup.string().required('Please Enter Days'),
  requestType: Yup.string().required('Please Enter Request Type'),
  reason: Yup.string().nullable(),
  employee: Yup.array(Yup.string()).nullable(),
  claimDate: Yup.string().required('Please Select Claim Date')
});

export const lopOvertimeRequestApprovedSchema = Yup.object({
  reason: Yup.string().required('Please Enter a Reason')
});

export const lopOvertimeRequestRejectedSchema = Yup.object({
  reason: Yup.string().required('Please Enter a Reason')
});
